import { addGroup, getFlexModelInfo, getProviderListAll, getScenario } from '@/services/flexGroup';
import { Button, Form, Input, InputNumber, message, Modal, Select } from 'antd';
import React, { useEffect, useState } from 'react';
import { ProviderType } from '../provider';
import type { GroupsType } from './index';

interface AddProps {
  visible: boolean;
  refreshTable: () => void;
  onCancel: () => void;
}

const AddModal = (addProps: AddProps) => {
  const { visible, onCancel, refreshTable } = addProps;
  const [form] = Form.useForm<GroupsType>();
  const [loading, setLoading] = useState(false);
  const [providers, setProviders] = useState<ProviderType[]>([]);
  const [scenarios, setScenarios] = useState<any[]>([]);

  const onOk = () => {
    form.validateFields().then((res) => {
      setLoading(true);
      addGroup(res)
        .then((msg) => {
          if (msg?.data.code === 'SUCCESS') {
            message.success('添加成功');
            onCancel();
            refreshTable();
          }
        })
        .finally(() => setLoading(false));
    });
  };

  useEffect(() => {
    getProviderListAll().then((res) => {
      setProviders(res?.data.records || []);
    });

    getScenario().then((res) => {
      setScenarios(res?.data.details);
    })
  }, []);

  const onAutoGet = () => {
    const addr = form.getFieldValue('modelUrl');
    console.log(form.getFieldValue('matchToken'))
    getFlexModelInfo({ modelUrl: addr }).then(res => {
      console.log(res)
      if (res.data.details) {
        form.setFieldsValue({ matchToken: res.data.details.matchToken })
      }
    })
  }

  return (
    <Modal
      title="新增"
      open={visible}
      onCancel={onCancel}
      onOk={onOk}
      width={600}
      maskClosable={false}
      okButtonProps={{ loading: loading }}
    >
      <div className="editModalContainer">
        <Form<GroupsType> labelCol={{ span: 6 }} wrapperCol={{ span: 18 }} form={form}>
          <Form.Item label="名称" name="name" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
          <Form.Item label="最大实例数" name="max" rules={[{ required: true }]}>
            <InputNumber />
          </Form.Item>
          <Form.Item label="期望实例数" name="expected" rules={[{ required: true }]}>
            <InputNumber />
          </Form.Item>
          <Form.Item label="standBy实例数" name="standBy" rules={[{ required: true }]}>
            <InputNumber />
          </Form.Item>
          <Form.Item label="供应商" name="provider" rules={[{ required: true }]}>
            <Select>
              {providers.map((item) => (
                <Select.Option value={item.id} key={item.id}>
                  {item.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            label="实例工作状态接口"
            name="workStatusCallbackUrl"
            rules={[{ required: true }]}
          >
            <Input.TextArea />
          </Form.Item>
          <Form.Item label="模型地址" name="modelUrl" >
            <Input />
          </Form.Item>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Form.Item labelCol={{ span: 5, offset: 2 }}
              wrapperCol={{ span: 16 }} label="匹配口令" name="matchToken" style={{ flex: 1 }}>
              <Input />
            </Form.Item>
            <Form.Item shouldUpdate noStyle>
              {
                () => (
                  <Button onClick={onAutoGet} style={{ marginBottom: 24 }} disabled={!form.getFieldValue('modelUrl')}>自动获取</Button>
                )
              }
            </Form.Item>
          </div>
          <Form.Item noStyle shouldUpdate>
            {() => (
              <Form.Item label="业务场景" name="scenario" rules={[{ required: !!form.getFieldValue('modelUrl') }]} >
                <Select >
                  {scenarios.map((item) => (
                    <Select.Option value={item.value} key={item.value}>{item.name}</Select.Option>
                  ))}
                </Select>
              </Form.Item>
            )}
          </Form.Item>
        </Form>
      </div>
    </Modal>
  );
};

export default AddModal;
